import {createContext} from 'react';
import {ContextValue} from './types';

const UserContext = createContext<ContextValue>(null);

export default UserContext;
